import React from "react";
import { Link } from "react-router-dom";

import twitter from "../assets/socialIcons/twitter.png";
import instagram from "../assets/socialIcons/instagram.png";
import youtube from "../assets/socialIcons/youtube.png";
import facebook from "../assets/socialIcons/facebook.png";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-10 px-4">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:justify-between md:items-start gap-10">

        {/* Left Section (Logo + Tagline) */}
        <div className="flex flex-col items-center md:items-start md:pl-10">
          <h2 className="text-lg font-semibold oxanium-font tracking-widest letter_spacing">
            FUSION SPIN
          </h2>
          <p className="mt-2 text-gray-400 poppins-font2 text-center md:text-left max-w-sm">
            Expert Solutions for Land Slot Machines – Anytime, Anywhere!
          </p>
        </div>

        {/* Center Section (Page Links) */}
        <div className="flex flex-col sm:flex-row gap-10 justify-center items-center md:items-start">
          <div className="flex flex-col gap-2 items-center md:items-start">
            <Link to="/" className="text-white hover:text-gray-300 transition">Home</Link>
            <Link to="/about" className="text-white hover:text-gray-300 transition">About</Link>
          </div>
          <div className="flex flex-col gap-2 items-center md:items-start">
            <Link to="/privacy-policy" className="text-white hover:text-gray-300 transition">Privacy Policy</Link>
            <Link to="/contact" className="text-white hover:text-gray-300 transition">Contact</Link>
          </div>
        </div>

        {/* Right Section (Social Icons) */}
        <div className="flex flex-col items-center md:items-end md:pr-10">
          <h3 className="text-base font-semibold pr-2 tracking-widest mb-3">Social Media</h3>
          <div className="flex space-x-4">
            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
              <img src={facebook} alt="Facebook" className="w-6 h-6 hover:scale-110 transition" />
            </a>
            <a href="https://x.com/" target="_blank" rel="noopener noreferrer">
              <img src={twitter} alt="Twitter" className="w-6 h-6 invert hover:scale-110 transition" />
            </a>
            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
              <img src={instagram} alt="Instagram" className="w-6 h-6 hover:scale-110 transition" />
            </a>
            <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
              <img src={youtube} alt="YouTube" className="w-6 h-6 hover:scale-110 transition" />
            </a>
          </div>
        </div>

      </div>

      {/* Bottom Section */}
      <div className="text-center mt-8 border-t border-gray-700 pt-6">
        <p className="text-gray-500">© 2025 Land Slots Platform</p>
      </div>
    </footer>
  );
};

export default Footer;
